import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { EditAvatarDialog } from "@/components/EditAvatarDialog";
import { Button } from "@/components/ui/button";

const KEY = "avatar-nudge-dismissed";

// Iter 143 — gentle prompt for anyone still on an auto-assigned cartoon face.
// Dismissal is remembered per person, and the banner disappears for good once
// they save any avatar.
export const AvatarNudge = ({ testid = "avatar-nudge" }) => {
  const { user, checkAuth } = useAuth();
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!user?.user_id) return;
    try { setDismissed(localStorage.getItem(KEY) === user.user_id); } catch { /* ignore */ }
  }, [user?.user_id]);
  const [saved, setSaved] = useState(false);

  if (!user || saved || dismissed || (user.avatar_url || "").trim()) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(KEY, user.user_id); } catch { /* ignore */ }
  };

  return (
    <div data-testid={testid}
      className="flex flex-wrap items-center gap-3 rounded-xl border border-primary/20 bg-primary/5 px-4 py-2.5">
      <Sparkles className="h-4 w-4 shrink-0 text-primary" />
      <p className="min-w-0 flex-1 text-sm text-foreground">
        <span className="font-semibold">Make the board yours.</span>{" "}
        <span className="text-muted-foreground">You&apos;re still on the face we picked for you — choose a cartoon, an anime icon, a robot, or upload your own photo.</span>
      </p>
      <Button size="sm" data-testid={`${testid}-open`} onClick={() => setOpen(true)}
        className="bg-primary text-primary-foreground hover:bg-primary/90">
        Pick your avatar
      </Button>
      <button type="button" onClick={dismiss} data-testid={`${testid}-dismiss`} title="Not now"
        className="text-muted-foreground transition-colors hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
      <EditAvatarDialog open={open} onOpenChange={setOpen} user={user}
        onSaved={(url) => { if (url) setSaved(true); checkAuth?.(); }} />
    </div>
  );
};
